/**
 * API base URL for portfolio data.
 * Always uses relative path /admin/api - proxied to mrakhudu.com in dev (see package.json proxy).
 * Production: same origin as deployed site.
 */
const API_BASE = '/admin/api';

export const ENDPOINTS = {
  about: `${API_BASE}/fetchAbout.php`,
  services: `${API_BASE}/fetchServices.php`,
  skills: `${API_BASE}/fetchSkills.php`,
  projectCategories: `${API_BASE}/fetchProjectCategories.php`,
  featuredProjects: `${API_BASE}/fetchFeaturedProjects.php`,
  projects: `${API_BASE}/fetchProjects.php`,
  education: `${API_BASE}/fetchEducation.php`,
  contactSubmit: `${API_BASE}/contact-submit.php`,
  chat: `${API_BASE}/chat.php`,
  chatbotPrompt: `${API_BASE}/fetchChatbotPrompt.php`,
  chatSave: `${API_BASE}/chat-save.php`,
  chatConversation: (sessionId) => `${API_BASE}/chat-conversation.php?session_id=${encodeURIComponent(sessionId)}`,
  projectContent: (slug) => `${API_BASE}/fetchProjectContent.php?project=${encodeURIComponent(slug)}`,
  fetchTechnologyTerms: `${API_BASE}/fetchTechnologyTerms.php`,
};

/** Admin API endpoints (use with credentials: 'include' for session auth) */
export const ADMIN_ENDPOINTS = {
  login: `${API_BASE}/login.php`,
  logout: `${API_BASE}/logout.php`,
  authCheck: `${API_BASE}/auth-check.php`,
  dashboardCounts: `${API_BASE}/dashboardCounts.php`,
  saveAbout: `${API_BASE}/saveAbout.php`,
  saveEducation: `${API_BASE}/saveEducation.php`,
  fetchSettings: `${API_BASE}/fetchSettings.php`,
  saveSettings: `${API_BASE}/saveSettings.php`,
  changePassword: `${API_BASE}/changePassword.php`,
  fetchMessages: `${API_BASE}/fetchMessages.php`,
  messageMarkRead: `${API_BASE}/messageMarkRead.php`,
  fetchServicesAdmin: `${API_BASE}/fetchServicesAdmin.php`,
  saveService: `${API_BASE}/saveService.php`,
  reorderServices: `${API_BASE}/reorderServices.php`,
  deleteService: `${API_BASE}/deleteService.php`,
  fetchSkillsAdmin: `${API_BASE}/fetchSkillsAdmin.php`,
  saveSkillsCategory: `${API_BASE}/saveSkillsCategory.php`,
  deleteSkillsCategory: `${API_BASE}/deleteSkillsCategory.php`,
  saveSkillsSubcategory: `${API_BASE}/saveSkillsSubcategory.php`,
  deleteSkillsSubcategory: `${API_BASE}/deleteSkillsSubcategory.php`,
  saveSkillsItem: `${API_BASE}/saveSkillsItem.php`,
  deleteSkillsItem: `${API_BASE}/deleteSkillsItem.php`,
  fetchProjectAdmin: (id) => `${API_BASE}/fetchProjectAdmin.php?id=${id}`,
  saveProject: `${API_BASE}/saveProject.php`,
  reorderProjects: `${API_BASE}/reorderProjects.php`,
  deleteProject: `${API_BASE}/deleteProject.php`,
  saveProjectCategory: `${API_BASE}/saveProjectCategory.php`,
  deleteProjectCategory: `${API_BASE}/deleteProjectCategory.php`,
  saveTechnologyTerm: `${API_BASE}/saveTechnologyTerm.php`,
  deleteTechnologyTerm: `${API_BASE}/deleteTechnologyTerm.php`,
  upload: `${API_BASE}/upload.php`,
  chatConversationsList: `${API_BASE}/chat-conversations-list.php`,
  chatConversationById: (id) => `${API_BASE}/chat-conversation.php?id=${id}`,
  chatReply: `${API_BASE}/chat-reply.php`,
};

/** Fetch with credentials for admin (session cookie) */
export function adminFetch(url, options = {}) {
  return fetch(url, { ...options, credentials: 'include' });
}

/** Fetch with full URL logged to console for debugging */
export function fetchWithLog(url, options) {
  const fullUrl = typeof url === 'string' ? url : url?.toString?.() ?? url;
  console.log('[fetch]', fullUrl);
  return fetch(url, options);
}
